import { render, staticRenderFns } from "./HistoryGrid.vue?vue&type=template&id=667f56ee"
import script from "./HistoryGrid.vue?vue&type=script&lang=ts"
export * from "./HistoryGrid.vue?vue&type=script&lang=ts"
import style0 from "./HistoryGrid.vue?vue&type=style&index=0&id=667f56ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports